module.exports = __webpack_public_path__ + "img/AO.0b77a06a.svg";